export const handleResponse = response => {
  if (!response.ok) {
    return response
      .json()
      .then(json => {
        // Display the error message from the server if possible
        return {
          status: response.status,
          data: {
            message: json.error
          }
        }
      })
      .catch(() => {
        return {
          status: response.status,
          data: {
            message: response.statusText
          }
        }
      })
      .then(error => {
        throw error
      })
  }

  return response.json().then(json => {
    json.status = response.status
    return json
  })
}



// WEBPACK FOOTER //
// ./src/utils/response-utils.js